import { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { YohanaLogo, AddCircleIcon } from '@yoweb/ui/components/Icon';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Box } from '@yoweb/ui/components/Box';
import { Button } from '@yoweb/ui/components/buttons';
import { NavButton } from './NavButton';
import { useTranslation } from '@yoweb/next-i18next';
import { useTasks } from '@poplar/contexts/TaskContext/TaskProvider';
import { PAGE_HOME } from '@poplar/constants/routes';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavLarge = function NavLarge(_ref) {
  var navItems = _ref.navItems;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';

  var _useState = useState(false),
      hasOverflow = _useState[0],
      setHasOverflow = _useState[1];

  var menuItemsRef = useRef(null);
  var menuNavItemsRef = useRef([]);

  var _useTasks = useTasks(),
      openTaskIntakeModal = _useTasks.actions.openTaskIntakeModal; // When any menu nav item size changes, check if the menu has overflow


  useEffect(function () {
    var el = menuNavItemsRef.current;
    if (!el) return;
    var resizeObserver = new ResizeObserver(function () {
      if (menuItemsRef.current) {
        var _menuItemsRef$current = menuItemsRef.current,
            scrollHeight = _menuItemsRef$current.scrollHeight,
            clientHeight = _menuItemsRef$current.clientHeight;
        setHasOverflow(scrollHeight > clientHeight);
      }
    });
    el.forEach(function (element) {
      resizeObserver.observe(element);
    });
    return function () {
      return resizeObserver.disconnect();
    };
  }, []);
  return /*#__PURE__*/_jsxs(NavContainer, {
    "data-testid": "poplar-nav",
    children: [/*#__PURE__*/_jsx(LogoRow, {
      spacing: isJapanLocale ? 'normal3' : 'medium1',
      children: /*#__PURE__*/_jsx(Link, {
        href: PAGE_HOME,
        passHref: true,
        "data-testid": "nav-logo",
        children: /*#__PURE__*/_jsx(YohanaLogo, {
          width: 96,
          height: 33
        })
      })
    }), /*#__PURE__*/_jsx(MenuItems, {
      ref: menuItemsRef,
      spacing: isJapanLocale ? 'normal3' : 'medium1',
      children: navItems.map(function (item, idx) {
        return /*#__PURE__*/_jsx(NavButton, {
          ref: function ref(el) {
            return menuNavItemsRef.current[idx] = el;
          },
          item: item
        }, item.name);
      })
    }), hasOverflow && /*#__PURE__*/_jsx(OverflowBar, {}), /*#__PURE__*/_jsx(Box, {
      w: "100%",
      mt: isJapanLocale ? 'normal3' : 'medium1',
      px: isJapanLocale ? 'normal3' : 'medium1',
      pb: isJapanLocale ? 'normal3' : 'medium1',
      children: /*#__PURE__*/_jsx(ButtonTodo, {
        isFullWidth: true,
        size: "lg",
        iconLeft: /*#__PURE__*/_jsx(AddCircleIcon, {
          size: 24
        }),
        onClick: function onClick() {
          return openTaskIntakeModal();
        },
        "data-testid": "nav-add-todo-button",
        children: t('actions.add-todo')
      })
    })]
  });
};
var ButtonTodo = styled(Button).withConfig({
  componentId: "sc-4jfqe0-0"
})(["&&{&:hover{background-color:", ";}}"], th.getColor('stone'));
var NavContainer = styled.div.withConfig({
  componentId: "sc-4jfqe0-1"
})(["position:sticky;top:0;left:0;height:100vh;width:", ";background-color:", ";display:grid;grid-template-rows:auto 1fr auto;overflow:hidden hidden;"], th.getSize('sideNavWidth'), th.getColor('base000'));
var LogoRow = styled.div.withConfig({
  componentId: "sc-4jfqe0-2"
})(["display:grid;justify-content:center;padding-top:", ";&:hover{color:", ";}"], function (_ref2) {
  var spacing = _ref2.spacing;
  return th.getSpace(spacing);
}, th.getColor('stone'));
var MenuItems = styled.div.withConfig({
  componentId: "sc-4jfqe0-3"
})(["padding:0 ", ";margin-top:", ";display:grid;align-content:start;gap:", ";overflow-y:overlay;"], function (_ref3) {
  var spacing = _ref3.spacing;
  return th.getSpace(spacing);
}, function (_ref4) {
  var spacing = _ref4.spacing;
  return th.getSpace(spacing);
}, th.getSpace('small2'));
var OverflowBar = styled.div.withConfig({
  componentId: "sc-4jfqe0-4"
})(["border-bottom:2px solid ", ";margin:0 ", ";"], th.getColor('sandMedium'), th.getSpace('medium1'));